import VueCookie from 'vue-cookie'
import {init as Sentryinit} from '@sentry/browser';


require('es6-promise').polyfill()

//Sentry
Sentryinit({ dsn: Laravel.config.sentry.dsn });


//JQuery
window.$ = window.jQuery = require('jquery')

//Vue.js
window.Vue = require('vue')

Vue.use(VueCookie)

//Axios
window.axios = require('axios')

//currencyFormatter
window.CurrencyFormatter = require('currencyformatter.js')

$.fn.extend({
    animateCss: function (animationName) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend'
        this.addClass('animated ' + animationName).one(animationEnd, function() {
            $(this).removeClass('animated ' + animationName)
        })
    }
})